<template>
<div class="chapter">
<div class="inner_page">
<h2 class="prect"><a id="pxi"></a><a href="#/Contents.htm#ch0c">List of Maps</a></h2>
<p class="mtxt"><a href="#/Preface.htm#Cap1">British and American POW Camps in German Territory, and British POW Camps in Italy</a></p>
<p class="linespace"></p>
<p class="mtxt"><a href="#/Preface.htm#Cap2">The Extent of the Japanese Occupation by July 1942</a></p>
<p class="linespace"></p>
<p class="mtxt"><a href="#/Preface.htm#Cap3">Singapore 1942</a></p>
<p class="linespace"></p>
<p class="mtxt"><a href="#/Preface.htm#Cap4">Route of the Thailand–Burma Railway</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// List_of_Maps.vue?8ed470fc